/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.theme_algolia_helpers = {}

/*
 * Unique ID shared with tag manager for form submission events.
 *
 * Form submission IDs are unique per page view rather than per form submission
 * because we cannot pull values back out of Typeforms.
 */
window.gtmUniqueFormId = window.gtmUniqueFormId || new Date().getTime() + '_' + Math.floor(Math.random() * 1000000000);

/*
 * Site name extracted from the URL.
 */
window.themeSiteName = (function() {
  var regex = /www\.([a-z]+)\.com/;
  var match = regex.exec(window.location.href);
  return match ? match[1] : null;
})();

/**
 * Shows a banner for visitors redirected from a transition page.
 *
 * Loads messages as a separate request, causing a layout shift when
 * the banner is added, so we don't serve to major crawlers.
 */
document.addEventListener('DOMContentLoaded', function() {
  var params = (new URL(window.location.href)).searchParams;
  var utmSource = params.get('utm_source');
  var utmCampaign = params.get('utm_campaign');
  var utmContent = params.get('utm_content');
  var isBot = /bot|google|baidu|bing|msn|teoma|slurp|yandex/i.test(navigator.userAgent);

  if (!isBot && utmCampaign === 'transition-page' && utmContent === 'redirect' && window.fetch) {

    // Don't display the banner if it's been dismissed.
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('redirect_banner_dismissed:' + utmSource)) {
      return;
    }

    // Load messages as JSON from special template.
    // We use a special list-collections template because the path doesn't change.
    var url = new URL('https://' + location.host + '/collections');
    url.searchParams.set('view', 'redirect');
    fetch(url.toString())
      .then(function(response) {
        return response.json();
      })
      .then(addBanner);

    // Add a banner before the main content.
    function addBanner(messages) {
      var html = null;
      messages.forEach(function(message) {
        if (message.source === utmSource) {
          html = message.html;
        }
      });
      if (!html) return;
      var banner = document.createElement('div');
      banner.classList.add('redirect-banner');
      banner.setAttribute('data-source', utmSource);

      var container = document.createElement('div');
      container.classList.add('container', 'redirect-banner__container');
      container.innerHTML = html;

      var wrapper = document.createElement('div');
      wrapper.classList.add('redirect-banner__button-wrapper');

      var button = document.createElement('button', 'redirect-banner__button');
      button.innerText = 'Dismiss';
      button.classList.add('button', 'button--extra-small', 'redirect-banner__button');
      button.onclick = function() {
        banner.setAttribute('hidden', true);
        if (typeof sessionStorage !== 'undefined') {
          sessionStorage.setItem('redirect_banner_dismissed:' + banner.dataset.source, true);
        }
      }

      wrapper.appendChild(button);
      container.appendChild(wrapper);
      banner.appendChild(container);
      document.getElementById('main').before(banner);
    }
  }
});

/**
 * Moves all inline modals the end of the page.
 *
 * Necessary to avoid z-index issues. Needs to be done early
 * before any event listeners are bound.
 */
document.addEventListener('DOMContentLoaded', function() {
  var body = document.querySelector('body');
  document.querySelectorAll('[data-modal-inlined]').forEach(function(modal) {
    body.append(modal);
  })
});

/**
 * Binds contact links in RTE text to open in a modal.
 */
document.addEventListener('DOMContentLoaded', function(event) {
  var containers = document.querySelectorAll('[data-contact-links-in-modal]');
  Array.from(containers).forEach(function(container) {
    var modalId = container.dataset.contactLinksInModal;
    var modal = modalId ? document.getElementById(modalId) : null;
    if (container && modal) {
      container.querySelectorAll('a').forEach(function(link) {
        var path = (new URL(link.href)).pathname;
        if (path && path.indexOf(window.routes.contactUrl) === 0) {
          link.setAttribute('data-action', 'open-modal');
          link.setAttribute('aria-controls', container.dataset.contactLinksInModal);
        }
      })
    }
  });
});

/**
 * Implements history state for variant changes.
 *
 * We disable the theme's native history state functionality and re-implement
 * here for more intelligent URL rewriting. The built-in implementation
 * overwrites all query parameters and fragments.
 */
 document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;
  var inQuickView = event.target.dataset.inQuickView;
  if (variant && inQuickView === "false") {
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({ path: url.toString() }, '', url.toString());
  }
});

/**
 * Activate print styles.
 */
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.hash && window.location.hash === '#print') {
    document.querySelectorAll('style').forEach(function(style) {
      style.remove();
    });
    document.querySelectorAll('link[rel="stylesheet"]').forEach(function(stylesheet) {
      if (stylesheet.getAttribute('media') !== 'print') {
        stylesheet.remove();
      }
      else {
        stylesheet.setAttribute('media', 'all');
      }
    });
    document.querySelectorAll('img.print-only').forEach(function(image) {
      image.src = image.getAttribute('data-src');
    });
  }
});

/**
 * Activate print styles for content after page load.
 *
 * TODO: Switch to native lazyloading once printing is supported.
 * @see https://bugs.chromium.org/p/chromium/issues/detail?id=875403
 */
document.addEventListener('theme:loading:end', function() {
  if (window.location.hash && window.location.hash === '#print') {
    document.querySelectorAll('img.print-only').forEach(function(image) {
      image.src = image.getAttribute('data-src');
    });
  }
});

/**
 * Updates series collection table on product pages when variant changes.
 */
document.addEventListener('DOMContentLoaded', function() {
  var seriesOptionsTable = document.querySelector('[data-series-options]');
  if (!seriesOptionsTable) return;

  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant;
    if (variant && event.target.dataset.inQuickView == 'false') {
      highlightActiveRow(variant);
    }
  });

  function highlightActiveRow(variant) {
    Array.from(seriesOptionsTable.querySelectorAll('.parts-row[data-series-option-id]')).forEach(function(row) {
      if (String(row.dataset.seriesOptionId) === String(variant.id)) {
        row.classList.add('parts-row--active');
      }
      else {
        row.classList.remove('parts-row--active');
      }
    })
  }
});

/**
 * Submits Basin forms via AJAX.
 */
document.addEventListener('DOMContentLoaded', function() {
  var basinForms = document.querySelectorAll('[data-basin-form]');

  basinForms.forEach(function(form) {
    var formUid = form.getAttribute('data-form-uid') || 'unidentified_form';
    var successMessage = form.querySelector('[data-basin-form-success]')
    var errorMessage = form.querySelector('[data-basin-form-error]')
    var submitButton = form.querySelector('[data-basin-form-submit]')
    var submitLabel = submitButton.textContent;
    var submittingLabel = submitButton.dataset.basinFormSubmitting || 'Please Wait...';

    // AJAX form handling.
    form.onsubmit = function(event) {
      event.preventDefault();
      var formData = new FormData(form);
      var xhr = new XMLHttpRequest();
      xhr.open('POST', form.action, true);
      xhr.onload = function(e) {
        var dataLayer = window.dataLayer || [];
        if (xhr.status === 200) {
          successMessage.style.display = 'block';
          errorMessage.style.display = 'none';
          submitButton.disabled = true;
          dataLayer.push({ event: 'formSubmission', formUID: formUid });
          document.dispatchEvent(
            new CustomEvent('theme.formSubmission', {
              detail: { formUID: formUid }
            })
          );
        }
        else {
          successMessage.style.display = 'none';
          errorMessage.style.display = 'block';
          dataLayer.push({ event: 'formError', formUID: formUid });
          document.dispatchEvent(
            new CustomEvent('theme.formError', {
              detail: { formUID: formUid }
            })
          );
        }
        submitButton.textContent = submitLabel;
      }
      xhr.send(formData);
      submitButton.textContent = submittingLabel;
    };

    // Add referrer as hidden field to provide more context.
    if (document.referrer && document.referrer.length) {
      var input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', 'referrer');
      input.setAttribute('value', document.referrer);
      form.appendChild(input);
    }
  });
});

/**
 * Implements popups for custom product CTAs.
 */
document.addEventListener('DOMContentLoaded', function() {

  // Sets up popups and binds to CTAs.
  function initialize(button, variant) {
    var ctaId = button.dataset.productCta;
    var config = window.themeCtaConfig[ctaId];
    var fields = Object.assign({}, config.fields);

    fields.ga = window.gtmUniqueFormId;
    fields.tid = config.uid + '_' + fields.ga;

    // Update with any new variant values passed.
    if (variant) {
      var url = new URL(fields.url);
      url.searchParams.set('variant', variant.id);
      fields['url'] = url.toString();
      fields['variant'] = variant.title === 'Default Title' ? 'Standard' : variant.title;
      fields['variant_id'] = variant.id;
      fields['sku'] = variant.sku;
    }

    if (config.type === 'hubspot') {
      hubspotFormInit(button, ctaId, config.pid, fields);
    }
    if (config.type === 'typeform') {
      typeformInit(button, ctaId, config.pid, fields);
    }

    // Enable theme's modal implementation.
    if (config.type === 'basin' || config.type === 'hubspot') {
      button.setAttribute('data-action', 'open-modal');
      button.setAttribute('aria-controls', ctaId);
    }
  }

  // Dynamically loads Typeform and sets hidden values.
  function typeformInit(button, ctaId, formId, fields) {
    var hiddenFields = {
      hubspot_page_name: document.title,
      hubspot_page_url: window.location.href,
      hubspot_utk: document.cookie.replace(/(?:(?:^|.*;\s*)hubspotutk\s*\=\s*([^;]*).*$)|^.*$/, "$1"),
    }
    var popup = window.tf.createPopup(formId, {
      size: 70,
      opacity: 100,
      hidden: Object.assign(hiddenFields, fields)
    })
    button.onclick = function() {
      popup.toggle();
      return false;
    };
  }

  // Dynamically loads HubSpot forms and sets hidden values.
  function hubspotFormInit(button, ctaId, formId, fields) {
    var containerSelector = '#' + ctaId + ' [data-hubspot-form-container]';
    var container = document.querySelector(containerSelector);

    // Clear form and reset state each time we initialize.
    container.innerHTML = '';
    button.classList.remove('hs-form-loaded');

    button.onclick = function() {
      // Only load the form once when the CTA is clicked.
      if (this.classList.contains('hs-form-loaded')) return;

      hbspt.forms.create({
        region: "na1",
        portalId: "40824579",
        formId: formId,
        formInstanceId: ctaId,
        target: containerSelector,
        onFormReady: function(form) {
          // Set values for all the hidden fields present.
          form.querySelectorAll('input[type="hidden"]').forEach(function(input) {
            if (input.name && fields[input.name]) {
              input.value = fields[input.name];
            }
          })
        }
      });

      this.classList.add('hs-form-loaded')
    };
  }

  // Initialize immediately.
  document.querySelectorAll('[data-product-cta]').forEach(function(button) {
    initialize(button);
  });

  // Re-initialize when the variant changes.
  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant;
    document.querySelectorAll('[data-product-cta]').forEach(function(button) {
      if (event.target.contains(button)) {
        initialize(button, variant);
      }
    })
  });
});

/**
 * Fix attributes on RTE links.
 *
 * This needs to run at window load, after theme.js scripts,
 * because we override behavior for old myshopify.com links,
 * which are actually internal.
 */
window.addEventListener('load', function() {
  var host = new RegExp('/' + window.location.host + '/');
  var shopify = new RegExp(/myshopify.com/);

  document.querySelectorAll('.rte a:not(.external)').forEach(function(link) {
    var isExternal = !host.test(link.href) && !shopify.test(link.href);
    var isInternal = !isExternal;

    if (isExternal) {
      // Override attribute added by theme.js
      link.setAttribute('rel', 'noopener noreferrer');
    }

    if (isInternal) {
      // Force internal links to open in current tab.
      link.removeAttribute('target');
      link.removeAttribute('rel');
      link.removeAttribute('aria-describedby');
    }

    if (isInternal && link.href.indexOf('http://') > -1) {
      // Fix scheme on old URLs which can will cause lost referrers / direct traffic.
      link.href = link.href.replace('http://', 'https://');
    }
  });
});

/**
 * Adds unique identifiers to forms.
 */
document.addEventListener('DOMContentLoaded', function(event) {
  function onlyExternalEndpoints(form) {
    var host = new RegExp('/' + window.location.host + '/');
    return !host.test(form.action);
  }

  var forms = Array.from(document.querySelectorAll('form')).filter(onlyExternalEndpoints);

  // Add IDs to Basin forms as hidden inputs.
  forms.forEach(function(form) {
    var input;

    input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', 'ga');
    input.setAttribute('value', window.gtmUniqueFormId);
    form.appendChild(input);

    input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', 'tid');
    input.setAttribute('value', form.dataset.formUid + '_' + window.gtmUniqueFormId);
    form.appendChild(input);
  });

  // Update variant info in forms when variant changes.
  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant || {};

    var inQuickView = event.target.dataset.inQuickView;
    if (inQuickView !== "false") return;

    forms.forEach(function(form) {
      var variantElement = form.querySelector('[name="variant"]') || {};
      var variantIdElement = form.querySelector('[name="variant_id"]') || {};
      var variantSkuElement = form.querySelector('[name="sku"]') || {};
      var urlElement = form.querySelector('[name="url"]');

      variantElement.value = variant.title === 'Default Title' ? 'Standard' : variant.title;
      variantIdElement.value = variant.id;
      variantSkuElement.value = variant.sku;

      if (urlElement) {
        var url = new URL(urlElement.value);
        url.searchParams.set('variant', variant.id);
        urlElement.value = url.toString();
      }
    });
  });

  var typeformEmbeds = Array.from(document.querySelectorAll('[data-tf-live]'));

  // Add IDs to embedded Typeforms.
  typeformEmbeds.forEach(function(element) {
    var values = {
      url: window.location.href,
      ga: window.gtmUniqueFormId,
      tid: window.themeSiteName + '_form_' + window.gtmUniqueFormId
    }
    var hidden = [];
    Object.keys(values).forEach(function(key) {
      hidden.push(key + '=' + encodeURIComponent(values[key]));
    });
    element.setAttribute('data-tf-hidden', hidden.join(','));
  });

});

/**
 * Disables / enables secondary product buttons when variant changes.
 */
 document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;
  var element = event.target;
  var buttons = element.querySelectorAll('[data-product-action-button]');
  buttons.forEach(function(button) {
    if (variant) {
      button.removeAttribute('disabled');
      button.classList.remove('button--disabled')
    }
    else {
      button.setAttribute('disabled', 'disabled');
      button.classList.add('button--disabled')
    }
  });
});

/**
* Updates current variant when Part Selector changes.
*/
document.addEventListener('DOMContentLoaded', function() {
  var selector = '[data-product-part-selector]';

  function onPartSelected(event) {
    var partSelector = event.target;
    var productForm = partSelector.closest('.product-form');
    var selectedOption = partSelector.options[partSelector.selectedIndex];
    var productOptions = [selectedOption.dataset.option1, selectedOption.dataset.option2, selectedOption.dataset.option3];

    productOptions.forEach(function(value, index) {
      if (value && productForm) {
        // TODO: Support block selectors here.
        var position = index + 1;
        var optionSelector = productForm.querySelector('select.product-form__single-selector[data-option-position="' + position + '"]');
        if (optionSelector) {
          optionSelector.value = value;
          optionSelector.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    partSelector.dispatchEvent(new Event('part-selector:changed', { bubbles: true }));
  }

  document.querySelectorAll(selector).forEach(function(select) {
    select.addEventListener('change', onPartSelected)
  });

  document.addEventListener('theme:custom:quick-view-loaded', function(event) {
    event.target.querySelectorAll(selector).forEach(function(select) {
      select.addEventListener('change', onPartSelected)
    });
  });
});

/**
 * Resets the Part Selector when the variant options are changed elsewhere.
 */
 document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;
  var element = event.target;
  if (!variant) return;
  element.querySelectorAll('[data-product-part-selector]').forEach(function(select) {
    var oldVariantId = String(select.value);
    var newVariantId = String(variant.id);
    if (oldVariantId !== newVariantId) {
      select.value = '';
    }
  });
});

/**
* Updates part numbers and barcodes when variant changes.
*
* Similar to what the theme does already with SKUs.
*/
document.addEventListener('DOMContentLoaded', function() {
  var selector = '[data-section-type="product"]';

  function initPartNumberDisplay(container) {
    var jsonElement = container.querySelector('[data-part-number-metafields-json]');
    var metafields = jsonElement ? JSON.parse(jsonElement.innerHTML) : {};

    container.addEventListener('variant:changed', function(event) {
      var variant = event.detail.variant || {};
      var id = variant.id ? String(variant.id) : 0;
      container.querySelectorAll('[data-part-number]').forEach(function(element) {
        var partNumberValue = '';
        var metafield = element.dataset.partNumberMetafield;
        var property = element.dataset.partNumberProperty;

        if (property) {
          partNumberValue = variant[property];
        }
        else if (metafield && metafields[id]) {
          partNumberValue = metafields[id][metafield];
        }

        element.querySelector('[data-part-number-value]').innerText = partNumberValue;

        if (partNumberValue) {
          element.removeAttribute('hidden');
        }
        else {
          element.setAttribute('hidden', '');
        }
      });
    });
  }

  // Bind to product forms on the page.
  var productSection = document.querySelector(selector);
  if (productSection) {
    initPartNumberDisplay(productSection);
  }

  // Bind to product forms inside quick views.
  document.addEventListener('theme:custom:quick-view-loaded', function(event) {
    var productSection = event.target.querySelector(selector);
    if (productSection) {
      initPartNumberDisplay(productSection);
    }
  });
});

/**
 * Implements events for quick view modals.
 *
 * This is necessary so we can attach dependent option selectors inside quick view.
 *
 * When the is-loading class is removed from a modal, it indicates the content has
 * been retrieved inserted by the theme. We simply watch for that mutation and
 * broadcast an event here.
 * @see theme.js CollectionSection._openQuickView
 */
document.addEventListener('DOMContentLoaded', function(event) {
  var quickViewModals = document.querySelectorAll('.modal--quick-view');
  if (!quickViewModals.length === 0) return;

  quickViewModals.forEach(function(modal) {
    var observer = new MutationObserver(function(mutationList) {
      mutationList.forEach(function(mutation) {
        var oldClassValue = mutation.oldValue || '';
        var newClassValue = mutation.target.className || '';
        if (oldClassValue.indexOf('is-loading') > -1 && newClassValue.indexOf('is-loading') === -1) {
          mutation.target.dispatchEvent(new Event('theme:custom:quick-view-loaded', { bubbles: true }));
        }
      });
    });

    observer.observe(modal, {
      attributes: true,
      attributeFilter: ['class'],
      attributeOldValue: true
    });
  })
});

/**
 * Sets up dependent option selectors on product pages.
 */
document.addEventListener('DOMContentLoaded', function(event) {
  var productSection = document.querySelector('[data-section-type="product"]');
  if (productSection) {
    initDependentOptionSelectors(productSection);
  }
});

/**
* Sets up dependent option selectors inside quick view.
*/
document.addEventListener('theme:custom:quick-view-loaded', function(event) {
  var productSection = event.target.querySelector('[data-section-type="product"]');
  if (productSection) {
    initDependentOptionSelectors(productSection);
  }
});

/**
 * Updates collection view links after page content has changed.
 *
 * This is necessary because the current URL changes when filtering.
 */
document.addEventListener('theme:loading:end', function(event) {
  document.querySelectorAll('[data-collection-view-link]').forEach(function(link) {
    var url = new URL(window.location);
    var view = link.dataset.collectionViewLink;
    if (!view) {
      url.searchParams.delete('view');
    }
    else {
      url.searchParams.set('view', view);
    }
    link.href= url.toString();
  })
});

/**
 * Helper to initialize dependent option selectors
 */
function initDependentOptionSelectors(productSection) {
  var productJsonElement = productSection.querySelector('[data-product-json]');
  var selectElements = productSection.querySelectorAll('.product-form__dependent-selector') || [];
  if (selectElements.length && productJsonElement) {
    new DependentOptionSelectors({
      container: productSection,
      product: JSON.parse(productJsonElement.innerHTML).product,
      selectors: Array.from(selectElements).reduce(function(selectors, element) {
        selectors['option' + element.getAttribute('data-option-position')] = element;
        return selectors;
      }, {}),
    });
  }
}

/**
 * Custom product option selectors that control the theme's built-in selectors.
 *
 * These selectors behave differently from the standard selectors. The second
 * and third options are always limited to valid values based on the selection
 * for the previous option. This prevents users from selecting an invalid set
 * of options.
 *
 * Rather than completely re-implementing option selector functionality, we keep
 * the theme's built-in option selectors hidden, and simply update them when our
 * custom option selectors change, which triggers all the necessary variant
 * selection code.
 */
var DependentOptionSelectors = (function() {

  function DependentOptionSelectors(options) {
    this.container = options.container;
    this.selectors = options.selectors;
    this.product = options.product;
    this.optionMap = this.buildOptionsMap();

    this.originalSelectors = {};
    for (var option in this.selectors) {
      this.originalSelectors[option] = document.getElementById(this.selectors[option].getAttribute('data-original-selector'))
    }

    for (var option in this.selectors) {
      this.selectors[option].addEventListener('change', this.onOptionChanged.bind(this));
    }

    this.container.addEventListener('sku-picker:changed', this.onSkuChanged.bind(this));
    this.container.addEventListener('part-selector:changed', this.onSkuChanged.bind(this));
    this.container.addEventListener('product-configurator:changed', this.onSkuChanged.bind(this));

    this.updateSelectors(this.getSelections());
  }

  DependentOptionSelectors.prototype = Object.assign({}, DependentOptionSelectors.prototype, {

    /**
     * Event handler for custom option selectors.
     */
    onOptionChanged: function() {
      this.updateSelectors(this.getSelections());
    },

    /**
     * Event handler for SKU selection.
     */
    onSkuChanged: function() {
      // The SKU picker updates the original option selectors, so we pull values from there.
      this.updateSelectors(this.getOriginalSelections());
    },

    /**
     * Gets the selected values from the custom option selectors.
     */
    getSelections: function() {
      var selections = [];
      selections[0] = this.selectors.option1 ? this.selectors.option1.value : null;
      selections[1] = this.selectors.option2 ? this.selectors.option2.value : null;
      selections[2] = this.selectors.option3 ? this.selectors.option3.value : null;
      return selections;
    },

    /**
     * Gets the selected values from the original option selectors.
     */
    getOriginalSelections: function() {
      var selections = [];
      selections[0] = this.originalSelectors.option1 ? this.originalSelectors.option1.value : null;
      selections[1] = this.originalSelectors.option2 ? this.originalSelectors.option2.value : null;
      selections[2] = this.originalSelectors.option3 ? this.originalSelectors.option3.value : null;
      return selections;
    },

    /**
     * Builds a nested lookup map of valid combinations of options.
     */
    buildOptionsMap: function() {
      var map =  {};
      var option1, option2, option3;

      this.product.variants.forEach(function(variant) {
        option1 = variant.option1;
        option2 = variant.option2;
        option3 = variant.option3;

        map[option1] = map[option1] || {};
        map[option1][option2] = map[option1][option2] || {};
        map[option1][option2][option3] = map[option1][option2][option3] || {};
      });

      return map;
    },

    /**
     * Updates custom selector options based on selected values.
     */
    updateSelectors: function(selections) {
      var valid = this.optionMap;

      var selectedOption1 = selections[0];
      var selectedOption2 = selections[1];
      var selectedOption3 = selections[2];

      var validOption2Values = [];
      var validOption3Values = [];

      // Collect all valid values for option #2 based on selected option #1.
      if (valid[selectedOption1]) {
        for (var value in valid[selectedOption1]) {
          validOption2Values.push(value);
        }
      }

      // Option selected for option #2 is no longer valid, need to choose new.
      if (validOption2Values.indexOf(selectedOption2) < 0) {
        selectedOption2 = validOption2Values[0];
      }

      // Collect all valid values for option #3 based on selected options for
      // both option #1 and #2.
      if (valid[selectedOption1] && valid[selectedOption1][selectedOption2]) {
        for (var value in valid[selectedOption1][selectedOption2]) {
          validOption3Values.push(value);
        }
      }

      if (validOption3Values.indexOf(selectedOption3) < 0) {
        selectedOption3 = validOption3Values[0];
      }

      this.setSelectListOption('option1', selectedOption1);

      this.updateSelectListOptions('option2', validOption2Values);
      this.setSelectListOption('option2', selectedOption2);

      this.updateSelectListOptions('option3', validOption3Values);
      this.setSelectListOption('option3', selectedOption3);
    },

    /**
     * Rebuilds all options in a single custom selector.
     */
    updateSelectListOptions: function(key, validValues) {
      var selector = this.selectors[key];
      if (selector) {
        while (selector.options.length > 0) {
          selector.remove(0);
        }
        validValues.forEach(function(value) {
          var option = new Option(value, value);
          selector.add(option);
        });
      }
    },

    /**
     * Sets the current value of a custom selector and updates the corresponding original selector.
     */
    setSelectListOption: function(key, value) {
      var selector = this.selectors[key];
      var originalSelector = this.originalSelectors[key];
      if (selector) {
        selector.value = value;
        if (originalSelector.value !== value) {
          originalSelector.value = value;
          originalSelector.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    },

  });

  return DependentOptionSelectors;
})();
